import { api } from 'app/config/apiConfig';
import { PaymentsStatisticsQueryParams, PaymentsStatisticsTotals } from '../model/types';

export const getPaymentsStatisticsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPaymentsStatisticsTotal: build.query<PaymentsStatisticsTotals, PaymentsStatisticsQueryParams>({
      query: (args) => ({
        url: '/warehouses/statistics/payments/total',
        params: args,
      }),
    }),
  }),
});

export const { useGetPaymentsStatisticsTotalQuery } = getPaymentsStatisticsApi;
